import React, { Component } from 'react';

import Form from 'react-bootstrap/Form';
import { Row } from 'react-bootstrap';
import SetupSubmitTable from '../../../components/v2/SetupSubmitTable';

export default function SetupStep3(props) {
    let department;
    let departmentId;

    if (props.departmentId) {
        department = props.departments.find((d) => d.departmentId == props.departmentId)
        departmentId = props.departmentId
    } else if (props.departments) {
        department = props.departments.find((d) => d.departmentId == props.department.departmentId)
        departmentId = props.department.departmentId
    }
    
    return (
        <div className="p-5 pb-md-4 mx-auto">
            <div className="p-3 text-center">
                <h3>Finalize Mappings</h3>
                <p className="fs-6 text-muted" style={{"textIndent":"50px"}}>
                    Indicate which mappings are now ready to be finalized and submitted
                    by selecting 'Yes' in the boxes below. Assessment of a program
                    (a degree, certificate, or gen ed area) can only begin after after a
                    finalized mapping has been submitted for it. Do not select 'Yes', for
                    programs that still have an unfinished mapping. The set up for those 
                    programs can be finalized later as long as they are not selected at 
                    this point.
                </p>
            </div>

            <div className="text-center">
                <Form.Group as={Row} className="mb-3" controlId="formDepartment">
                    <Form.Label column="lg" sm="4">
                        Department
                    </Form.Label>
                    <Form.Label column="lg" sm="8" className="text-muted">
                        { department?.longName }
                    </Form.Label>
                </Form.Group>
            </div>

            <div className="text-center">
                <Form.Group as={Row} className="mb-3" controlId="formDepartment">
                    <Form.Label column="lg" sm="4">
                        Staff Member
                    </Form.Label>
                    <Form.Label column="lg" sm="8" className="text-muted">
                        {props.currentUser}
                    </Form.Label>
                </Form.Group>
            </div>
            
            <SetupSubmitTable
                departmentId={props.departmentId}
                department={props.department}
                departments={props.departments}
                programId={props.programId}
                activePrograms={props.activePrograms}
                learningOutcomeMappings={props.learningOutcomeMappings}
                submittedPrograms={props.submittedPrograms}
                onSetupSubmitChanged={props.onSetupSubmitChanged}
                />

            <div style={{margin: "auto", width: "70%"}}>
                <p className="fs-6 text-muted">
                    Only programs that were selected for set up are seen here. To set
                    up other programs, use the back button to return to the 
                    "Identify Programs to Assess" page and select the additional programs 
                    to set up.
                </p>
            </div>
        </div>
    )
}
